import type { MatchPhase } from '../schemas/matches.js'

/** Massima potenza di 2 strettamente minore di n: almeno una squadra è sempre eliminata. */
export function advancingCount(teamCount: number): number {
  let p = 1
  while (p * 2 < teamCount) p *= 2
  return p
}

/** Ordine standard dei seed in un tabellone da `size` posti: 1 e 2 agli estremi, i vincitori adiacenti si incontrano. */
export function seedOrder(size: number): number[] {
  let order = [1]
  while (order.length < size) {
    const next = order.length * 2
    order = order.flatMap((seed) => [seed, next + 1 - seed])
  }
  return order
}

const NAMED: Record<number, MatchPhase> = { 2: 'final', 4: 'semifinal', 8: 'quarterfinal', 16: 'round_of_16', 32: 'round_of_32' }

/** Nome della fase per un turno con `size` squadre; oltre i sedicesimi `knockout_round_<log2>`. */
export function phaseForSize(size: number): MatchPhase {
  return NAMED[size] ?? (`knockout_round_${Math.log2(size)}` as MatchPhase)
}

/** Ordine di visualizzazione delle fasi (girone → … → finalina → finale). */
export const PHASE_ORDER: readonly string[] = ['group', 'knockout_round_7', 'knockout_round_6', 'round_of_32', 'round_of_16', 'quarterfinal', 'semifinal', 'third_place', 'final']

export type BracketMatch = { homeTeamId: string; awayTeamId: string; phase: MatchPhase; sortOrder: number }

/** Primo turno a eliminazione dalle squadre in ordine di classifica (indice 0 = prima). */
export function generateFirstRound(rankedTeamIds: readonly string[]): BracketMatch[] {
  const count = advancingCount(rankedTeamIds.length)
  const order = seedOrder(count)
  const phase = phaseForSize(count)
  const matches: BracketMatch[] = []
  for (let i = 0; i < order.length; i += 2) {
    matches.push({ homeTeamId: rankedTeamIds[order[i] - 1], awayTeamId: rankedTeamIds[order[i + 1] - 1], phase, sortOrder: i / 2 })
  }
  return matches
}

/** Turno successivo: i vincitori a coppie adiacenti, nell'ordine delle partite. */
export function pairWinners(winnerIds: readonly string[]): [string, string][] {
  const pairs: [string, string][] = []
  for (let i = 0; i + 1 < winnerIds.length; i += 2) pairs.push([winnerIds[i], winnerIds[i + 1]])
  return pairs
}
